import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import AdminLoadingScreen from './components/AdminLoadingScreen';
import ProtectedRoute from './components/ProtectedRoute';
import AdminLayout from './components/AdminLayout';
import LoginPage from './pages/LoginPage';
import './styles/index.css';

const DashboardPage = lazy(() => import('./pages/DashboardPage'));
const ProductsPage = lazy(() => import('./pages/ProductsPage'));
const ProductFormPage = lazy(() => import('./pages/ProductFormPage'));
const BrandsPage = lazy(() => import('./pages/BrandsPage'));
const CategoriesPage = lazy(() => import('./pages/CategoriesPage'));
const SuppliersSection = lazy(() => import('./pages/SuppliersSection'));

function VistaProductoRedirect() {
  const { id } = useParams();
  return <Navigate to={`/leoradmin/productos/${id}`} replace />;
}

function AdminFallback() {
  return <AdminLoadingScreen variant="page" message="Cargando panel..." />;
}

export default function AdminRoutes() {
  return (
    <AuthProvider>
      <ToastProvider>
        <Suspense fallback={<AdminFallback />}>
          <Routes>
            <Route path="login" element={<LoginPage />} />
            <Route
              path="/"
              element={(
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              )}
            >
              <Route index element={<DashboardPage />} />
              <Route path="productos" element={<ProductsPage />} />
              <Route path="productos/nuevo" element={<ProductFormPage />} />
              <Route path="productos/:id" element={<ProductFormPage />} />
              <Route path="marcas" element={<BrandsPage />} />
              <Route path="categorias" element={<CategoriesPage />} />
              <Route path="proveedores" element={<SuppliersSection />} />
              <Route
                path="productos-proveedores"
                element={<Navigate to="/leoradmin/proveedores?tab=productos" replace />}
              />
              <Route path="vista-productos" element={<Navigate to="/leoradmin/productos" replace />} />
              <Route path="vista-productos/:id" element={<VistaProductoRedirect />} />
            </Route>
            <Route path="*" element={<Navigate to="/leoradmin" replace />} />
          </Routes>
        </Suspense>
      </ToastProvider>
    </AuthProvider>
  );
}
